import HttpClient from "../../HttpClient.ts";
import apiRoutes from "../../Routes/Routes.json";

export const getAllData = (object) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumeGetAllData}`,
    object
  );
};

export const SavePGXCompendium = (obj) => {
  return HttpClient().post(
    apiRoutes.PgxCompendiumData.PgxCompendiumSaveData,
    obj
  );
};

export const DeletePGXCompendium = (obj) => {
  return HttpClient().post(
    apiRoutes.PgxCompendiumData.PgxCompendiumDeleteData,
    obj
  );
};

export const PGXDownloadTemplate = (obj) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumDownloadData}`,
    obj
  );
};

export const PGXCompandiumUpload = (jsonstring) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumUploadData}`,
    jsonstring
  );
};

export const PGXCompandiumExportToExcel = (ids) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumExportData}`,
    ids
  );
};
export const PGXCompandiumTestExport = (ids) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumTestExportData}`,
    ids
  );
};

export const PGXCompendiumGroupLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumGroupLookup}`
  );
};

export const TestGetAllData = (object) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumTestGetAllData}`,
    object
  );
};

export const SavePGXCompendiumTest = (obj) => {
  return HttpClient().post(
    apiRoutes.PgxCompendiumData.PgxCompendiumTestSaveData,
    obj
  );
};

export const DeletePGXCompendiumTest = (id) => {
  const path = `${apiRoutes.PgxCompendiumData.PgxCompendiumTestDeleteData}${id}`;
  return HttpClient().delete(path);
};
export const PGXTextDownloadTemplate = () => {
  return HttpClient().get(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumTextDownloadData}`
  );
};
export const PGXCompandiumTextUpload = (jsonstring) => {
  return HttpClient().post(
    `/${apiRoutes.PgxCompendiumData.PgxCompendiumTextUploadData}`,
    jsonstring
  );
};

export const PGXCompGeneLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.PgxCompendiumData.PgcCompendiumGeneLookup}`
  );
};
